import { Component, ViewChild, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedZorroModule } from '../../shared-zorro.module';
import { RouterModule, Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { UserService } from '../../service/user.service';
import { environment } from '../../../environments/environment';
import lodash from 'lodash';
import dayjs from 'dayjs';
import { SearchGroupSettingComponent } from '../component/search-group-setting/search-group-setting.component';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
@Component({
  selector: 'app-upload-list',
  standalone: true,
  imports: [CommonModule, SharedZorroModule, RouterModule],
  templateUrl: './upload-list.component.html',
  styleUrl: './upload-list.component.less',
})
export class UploadListComponent {
  @ViewChild('searchGroupDrawerFooter', { static: true }) searchGroupDrawerFooter!: TemplateRef<{}>;
  searchParams: any = {
    patientName: '',
    date: [],
    deviceTypes: [],
    pageSize: 10,
    pageIndex: 1,
  };
  searchGroups: any[] = [];
  selectedGroup: any = {
    id: '',
  };
  total: number = 0;
  quickDateType: string = 'today';
  deviceList: any[] = [
    {
      label: 'CT',
      value: 'CT',
    },
    {
      label: 'DR',
      value: 'DR',
    },
    {
      label: 'CR',
      value: 'CR',
    },
    {
      label: 'RF',
      value: 'RF',
    },
    {
      label: 'MR',
      value: 'MR',
    },
    {
      label: 'US',
      value: 'US',
    },
    {
      label: 'NM',
      value: 'NM',
    },
    {
      label: 'XA',
      value: 'XA',
    },
    {
      label: 'OT',
      value: 'OT',
    },
  ];
  showTotal: boolean = true;
  dataList: any[] = [];
  isVisibleQrCode: boolean = false;
  showReplenish: boolean = false;
  replenishCaseForm: any = {};

  qcCodeURL: string = '';
  status: any = {
    UPLOADED: '已上传',
    REPORTED: '已报告',
    AUDITED: '已审核',
    RECALLED: '已撤回',
  };
  tableName: string = 'uploadList'; //定义全局唯一表格名称
  examinationTypeList: any[] = [
    { label: '门诊', value: 'OUTPATIENT' },
    { label: '住院', value: 'INPATIENT' },
    { label: '体检', value: 'EXAMINATION' },
    { label: '急诊', value: 'EMERGENCY' },
    { label: '其他', value: 'OTHER' },
  ];
  scanMethodList: any[] = [
    { label: '平扫', value: '平扫' },
    { label: 'CT增强', value: 'CT增强' },
    { label: 'MR增强', value: 'MR增强' },
    { label: 'MR血管成像', value: 'MR血管成像' },
    { label: 'MR功能成像', value: 'MR功能成像' },
    { label: 'MR扫描', value: 'MR扫描' },
    { label: 'MR脑电图', value: 'MR脑电图' },
  ];
  searchGroupItem: any = {};
  searchGroupDrawer: any;
  constructor(private message: NzMessageService, private userService: UserService, private router: Router, private drawerService: NzDrawerService) {
    this.setDefaultDate();
    this.getTableData();
    this.getSearchGroups();
    this.getTabelHeader();
  }

  ngOnInit() {}

  search() {
    this.getTableData();
  }
  reset() {
    this.searchParams = {
      patientName: '',
      date: [],
      deviceTypes: [],
      pageSize: 10,
      pageIndex: 1,
    };
    this.setDefaultDate();
    this.getTableData();
  }
  //设置默认时间近一个月
  setDefaultDate() {
    this.searchParams.date = [dayjs().subtract(1, 'year').toDate(), dayjs().toDate()];
  }
  pageIndexChange(val: any) {
    this.searchParams.pageIndex = val;
    this.getTableData();
  }
  pageSizeChange(val: any) {
    this.searchParams.pageSize = val;
    this.getTableData();
  }
  getTableData() {
    let params = {
      page: this.searchParams.pageIndex,
      size: this.searchParams.pageSize,
      patientName: this.searchParams.patientName,
      submitDateStart: dayjs(this.searchParams.date[0]).format('YYYY-MM-DD'),
      submitDateEnd: dayjs(this.searchParams.date[1]).format('YYYY-MM-DD'),
      deviceTypes: this.searchParams.deviceTypes.join(','),
    };
    this.userService.getUploadList(params).subscribe((res) => {
      if (res.code === 0) {
        this.dataList = res.data.content;
        this.total = res.data.totalElements;
      } else {
        this.message.error(res.msg);
      }
    });
  }
  //查询用户的查询组
  getSearchGroups() {
    let params: any = {
      tableName: this.tableName,
    };
    this.userService.getSearchGroups(params).subscribe((res) => {
      if (res.code === 0) {
        this.searchGroups = res.data;
      } else {
        this.message.error(res.msg);
      }
    });
  }
  //查询小程序二维码
  showQrCode(item: any) {
    this.isVisibleQrCode = true;
    this.qcCodeURL = environment.host + '/portal/api/v1/portal/examinations/' + item.id + '/shareQrCode';
    // this.userService.getEfilmQrCode({ examinationId: item.id }).subscribe((res) => {
    //   if (res.code === 0) {
    //   } else {
    //     this.message.error(res.msg);
    //   }
    // });
  }

  //打开模态框
  showQrModal(item: any) {
    this.showQrCode(item);
  }

  handleCancelMiddle() {
    this.isVisibleQrCode = false;
  }
  handleOkMiddle() {
    this.isVisibleQrCode = false;
  }

  //下载pdf报告
  downloadReport(item: any) {
    this.userService.downloadReport(item.id).subscribe((res: any) => {
      let fileName = item.checkSerialNum + '.pdf';
      this.userService.downloadFile(res, fileName, 'application/pdf');
    });
  }

  //编辑查询组
  showEditGroupModal() {
    this.router.navigate(['/admin/upload-list/edit-group']);
  }

  //查询表头
  getTabelHeader() {
    this.userService.getTabelHeader(this.tableName).subscribe((res) => {
      // console.log(res);
    });
  }

  //新窗口打开报告
  openReport(item: any) {
    window.open('/admin/report/print' + item.id);
  }

  //补录case
  async replenishCase(item: any) {
    this.showReplenish = true;
    const caseDetail = await this.getCaseDetail(item.id);
    this.replenishCaseForm = caseDetail;
    let TypeKey = lodash.find(this.examinationTypeList, { label: item.patientType });
    if (TypeKey) {
      this.replenishCaseForm.type = TypeKey.value;
    }
  }

  //提交补录信息
  submitReplenish() {
    if (!this.validateReplenish()) {
      return;
    }
    let params = this.replenishCaseForm;
    params.examinationId = this.replenishCaseForm.id;
    this.userService.replenishCase(this.replenishCaseForm).subscribe((res: any) => {
      if (res.code === 0) {
        this.message.success('补录成功');
        this.showReplenish = false;
        this.getTableData();
      } else {
        this.message.error(res.message);
      }
    });
  }

  //校验必填项
  validateReplenish() {
    //必填项为：姓名，性别，年龄，检查类型，检查部位，患者手机号，患者身份证号
    let flag = true;
    if (!this.replenishCaseForm.patientName) {
      this.message.error('请填写患者姓名');
      flag = false;
    }
    if (!this.replenishCaseForm.patientGender) {
      this.message.error('请选择患者性别');
      flag = false;
    }
    if (!this.replenishCaseForm.patientAge) {
      this.message.error('请填写患者年龄');
      flag = false;
    }
    if (!this.replenishCaseForm.examinationType) {
      this.message.error('请选择检查类型');
      flag = false;
    }
    if (!this.replenishCaseForm.bodyPartExamined) {
      this.message.error('请填写检查部位');
      flag = false;
    }
    if (!this.replenishCaseForm.patientPhone) {
      this.message.error('请填写患者手机号');
      flag = false;
    } else {
      //判断手机号格式
      let reg = /^1[3456789]\d{9}$/;
      if (!reg.test(this.replenishCaseForm.patientPhone)) {
        this.message.error('手机号格式不正确');
        flag = false;
      }
    }
    if (!this.replenishCaseForm.patientIdCard) {
      this.message.error('请填写患者身份证号');
      flag = false;
    } else {
      //判断身份证号格式
      let regIdCard = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (!regIdCard.test(this.replenishCaseForm.patientIdCard)) {
        this.message.error('身份证号格式不正确');
        flag = false;
      }
    }
    if (!this.replenishCaseForm.clinicalAdvice) {
      this.message.error('请填写临床诊断');
      flag = false;
    }
    return flag;
  }

  //格式化性别
  formatGender(value: any) {
    return this.userService.formatGender(value);
  }

  //getStatusClass
  getStatusClass(value: any) {
    return this.userService.getStatusClass(value);
  }

  //格式化时间
  formatTime(value: any) {
    return dayjs(value).format('YYYY-MM-DD HH:mm:ss');
  }

  //通过结果获取case详情
  getCaseDetail(id: any) {
    return new Promise((resolve, reject) => {
      this.userService.getUploadCaseDetail({ id: id }).subscribe((res) => {
        if (res.code === 0) {
          resolve(res.data);
        } else {
          reject({});
          this.message.error(res.msg);
        }
      });
    });
  }

  //新增查询组
  addGroup() {
    this.searchGroupItem = {
      name: '',
      tableName: 'workbench',
      predicates: {
        examinationStatuses: [],
        examinationTypes: [],
        sourceHospitalIdList: [],
        doctors: [],
        deviceTypes: [],
      },
    };
    this.editGroup(this.searchGroupItem);
  }

  //编辑查询组
  editGroup(item: any) {
    this.searchGroupItem = item;
    //打开右侧侧栏
    this.searchGroupDrawer = this.drawerService.create({
      nzTitle: '设置查询组',
      nzContent: SearchGroupSettingComponent,
      nzWidth: '400px',
      nzClosable: true,
      nzData: {
        data: this.searchGroupItem,
      },
      nzFooter: this.searchGroupDrawerFooter,
    });
  }

  //删除查询组
  deleteGroup() {
    this.userService.deleteSearchGroup(this.searchGroupItem.id).subscribe((res: any) => {
      if (res.code === 0) {
        this.message.success('删除成功');
        this.getSearchGroups();
        this.searchGroupDrawer.close();
      } else {
        this.message.error(res.msg);
      }
    });
  }

  onSubmitSearchGroup() {
    let searchParams = this.searchGroupDrawer.getContentComponent().getValues();
    let params: any = {
      name: searchParams.name,
      tableName: this.tableName,
      predicates: searchParams.predicates,
    };
    if (this.searchGroupItem.id) {
      params.id = this.searchGroupItem.id;
    }
    this.userService.addSearchGroup(params).subscribe((res) => {
      if (res.code === 0) {
        this.message.success('保存成功');
        this.getSearchGroups();
        this.searchGroupDrawer.close();
      } else {
        this.message.error(res.msg);
      }
    });
  }

  onCancelSearchGroup() {
    this.searchGroupDrawer.close();
  }
}
